import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';

import { VOFilters, VOFilterType } from '../../types';
import { useFilterOptions } from '../../../../list/api';

export const OpportunityType = () => {
  const { control } = useFormContext<VOFilters>();

  const { options, loading } = useFilterOptions(VOFilterType.OPPORTUNITY_TYPE);

  const mappedOptions = options.map(({ label, value }) => ({ label, value }));

  return (
    <AutocompleteField
      multiple
      size="small"
      name="OPPORTUNITY_TYPE"
      loading={loading}
      control={control}
      disableCloseOnSelect
      options={mappedOptions}
      disabled={!mappedOptions.length}
      textFieldProps={{
        size: 'small',
        label: 'Opportunity Type',
        variant: 'outlined',
      }}
    />
  );
};
